import { Component, Input, HostListener } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageViewerModalComponent } from '../image-viewer-modal/image-viewer-modal.component';

export interface ImageItem {
  typeLabel: string;
  filename?: string;
  originalUrl?: string;
  largeUrl?: string;
  mediumUrl?: string;
  thumbUrl?: string;
}

@Component({
  selector: 'app-image-list-modal',
  templateUrl: './image-list-modal.component.html',
  styleUrls: ['./image-list-modal.component.css'],
  standalone: false
})
export class ImageListModalComponent {
  @Input() images: ImageItem[] = [];
  @Input() modalTitle: string = 'Images';

  imageLoaded: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal
  ) { }


  trackByFilename(index: number, item: ImageItem): string | undefined {
    return item.filename;
  }

  openImageViewer(image: ImageItem): void {
    try {
      this.activeModal.dismiss();

      const modalRef = this.modalService.open(ImageViewerModalComponent, {
        backdrop: true,
        centered: false,
        size: 'xl',
        windowClass: 'image-viewer-modal fullscreen-modal',
        animation: false
      });

      modalRef.componentInstance.imageUrl = image.largeUrl;
      modalRef.componentInstance.imageTitle = image.filename;
      modalRef.componentInstance.images = this.images;
      modalRef.componentInstance.currentIndex = this.images.findIndex(img => img.filename === image.filename);
    } catch (error) {
      console.error('Failed to open image viewer:', error);
    }
  }

  closeModal(): void {
    this.activeModal.dismiss();
  }


}